import angular from 'angular';

class LicenseButtonController {
    constructor($uibModal) {
        'ngInject';
        this.$uibModal = $uibModal;
    }
    openPopup() {
        this.$uibModal.open({
            component: 'licensePopup',
            resolve: {
                companyId: this.companyId
            },
            size: 'md',
            backdrop: 'static',
            windowClass: 'license-popup',
            appendTo: this.modalAppendTo && angular.element(this.modalAppendTo),
        }).result.then(() => {
            this.saved();
        }, () => {});
    }
}

export default LicenseButtonController;


// WEBPACK FOOTER //
// ./components/popups/license-popup/button/license-button.controller.js